<template>
  <v-card flat class="outline">
    <!-- Section header -->
    <v-card-title v-if="level > 0 && translatedLabel" class="grey lighten-5">
      <span class="title">{{ translatedLabel }}</span>
    </v-card-title>
    <v-card-text v-if="level > 0 && translatedDescription" class="pt-0 grey lighten-5">
      <span>{{ translatedDescription }}</span>
    </v-card-text>
    <v-divider v-if="level > 0 && (translatedLabel || translatedDescription)"></v-divider>
    <!-- Section contents -->
    <v-container grid-list-md class="pa-2">
      <v-layout wrap>
        <v-flex v-for="(item, key) in items" :key="key" :class="getInputContainerClass(item)">
          <!-- Render: info -->
          <checklist-info
            v-if="(/info/).test(item.type)"
            :level="item.lvl"
            :index="item.idx"
            :label="item.label"
            :description="item.description"
            :translation="item.translation || {}"
          ></checklist-info>
          <checklist-image
            v-if="(/image/).test(item.type)"
            :level="item.lvl"
            :index="item.idx"
            :label="item.label"
            :description="item.description"
            :translation="item.translation || {}"
            :items="item.items"
          ></checklist-image>
          <!-- Render: section -->
          <checklist-section
            v-if="(/section/).test(item.type)"
            :level="item.lvl"
            :index="item.idx"
            :label="item.label"
            :description="item.description"
            :translation="item.translation || {}"
            :items="item.items"
          ></checklist-section>
          <!-- Render: input -->
          <checklist-input
            v-if="(/switch|number|string|file|graph/).test(item.type)"
            :level="item.lvl"
            :index="item.idx"
            :label="item.label"
            :description="item.description"
            :translation="item.translation || {}"
            :validations="item.validations"
            :items="item.items"
            :type="item.type"
            :source="item.source"
            :length="item.length"
          ></checklist-input>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<style>
  .outline {
    border: 1px solid #eee !important;
    border-radius: 2px;
  }
</style>

<script>
import ChecklistSection from './checklist-section.vue'
import ChecklistInfo from './checklist-info.vue'
import ChecklistImage from './checklist-image.vue'
import ChecklistInput from './checklist-input.vue'
import translationMixin from './checklist-translation-mixin.es6'

export default {
  name: 'checklist-section',
  props: {
    level: Number,
    index: Number,
    items: Array,
    label: String,
    description: String
  },
  mixins: [translationMixin],
  methods: {
    getInputContainerClass (item) {
      const narrow = item.length === 'narrow'
      return {
        'pa-2': true,
        'xs12': true,
        'sm6': narrow,
        'md4': narrow,
        'lg3': narrow
      }
    }
  },
  components: {
    ChecklistSection,
    ChecklistInfo,
    ChecklistImage,
    ChecklistInput
  }
}
</script>
